import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';
import { dsnPageTestId } from './test-ids';

type ClosedPeriodDialogProps = {
  open: boolean;
  onClose: () => void;
};

const ClosedPeriodDialog: React.FC<ClosedPeriodDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="closed-period-dialog-title"
      aria-describedby="closed-period-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 0,
        },
      }}
    >
      <DialogTitle
        id="closed-period-dialog-title"
        component="h2"
        sx={{
          fontSize: '1.25rem',
          fontWeight: 600,
          color: 'text.primary',
          pb: 0,
        }}
      >
        Closed Period – Action Not Allowed
      </DialogTitle>
      <DialogContent>
        <Typography
          id="closed-period-dialog-description"
          variant="body2"
          sx={{ color: '#6C737F', fontWeight: 400, pt: 2 }}
          component="div"
        >
          This daily session note falls within a closed period and cannot be created, edited,
          archived, or held from billing.
          <br />
          <br />
          If changes are needed, please contact your therapy manager and request that the period be
          reopened.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Button
          data-testid={dsnPageTestId('closed-period-close')}
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: 'none',
          }}
        >
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClosedPeriodDialog;
